import { ComponentDataSourceService } from '../component-data-source.service';
import { Observable } from 'rxjs';
import { DataSourceFunction } from '../component-data-source.service';
import { Event } from '../../../interfaces/old/event.interfaces';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../environment/environment';

export const user_upcoming_events = (service: ComponentDataSourceService): DataSourceFunction => ({
  name: 'user_upcoming_events',
  description: 'Get upcoming events for a user',
  execute: (params?: LoadDataParams): Observable<Event[]> => {
    const queryParams: any = {};
    if (params?.filters) {
      const userFilter = params.filters.find(f => f.column === 'userId');
      if (userFilter) {
        queryParams.userId = userFilter.value;
        return service.http.get<Event[]>(`${environment.apiUrl}/users/${userFilter.value}/upcoming-events`, { params: queryParams });
      }
    }
    return service.http.get<Event[]>(`${environment.apiUrl}/users/upcoming-events`, { params: queryParams });
  }
}); 